import { render, staticRenderFns } from "./previewXWXX.vue?vue&type=template&id=1aa83878&scoped=true&"
import script from "./previewXWXX.vue?vue&type=script&lang=js&"
export * from "./previewXWXX.vue?vue&type=script&lang=js&"
import style0 from "./previewXWXX.vue?vue&type=style&index=0&id=1aa83878&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa83878",
  null
  
)

export default component.exports